module.exports = __webpack_public_path__ + "img/bg3.034d13cb.png";